import { createSelector } from 'reselect';
import { subselect } from './root';
import { answerSelector } from './answer';

const isAnsweredSelector = createSelector([answerSelector], (answer) => !!answer);

export const triviaIsAnsweredSelector = subselect(isAnsweredSelector);
